"use client";

import { CheckIcon } from "../CheckIcon";
import { ReviewsRow } from "../ReviewsRow";

const STEPS_AHEAD = [
  "Share a few business details",
  "Choose the services to support your business",
  "Review and complete checkout",
];

/**
 * The self-serve entry point for the "Manage existing business" branch — the
 * counterpart to RegisterIntroStep on the register branch. Same shape (heading,
 * what-happens-next list, one CTA), with the reviews row added and no
 * service-name sub-heading; worth folding into one component if a third
 * branch turns up.
 */
export function SwitchIntroStep({ onStart }: { onStart: () => void }) {
  return (
    <div className="mx-auto flex min-h-[calc(100dvh-64px)] w-full max-w-[792px] flex-col items-start justify-center gap-6 px-4 py-10 sm:min-h-0 sm:justify-start sm:gap-8 sm:px-6 sm:pb-24 sm:pt-12 lg:pt-[62px]">
      <div className="flex w-full max-w-[695px] flex-col items-start gap-3 sm:gap-[17px]">
        <h1 className="font-suisse-intl-bold text-[28px] leading-tight text-white sm:text-5xl lg:text-[64px] lg:leading-[71px]">
          Switch to MuteTaxes with confidence
        </h1>

        {/* Two paragraphs rather than the export's double <br/>: same blank
            line, without leaning on line breaks for spacing. */}
        <div className="flex flex-col items-start gap-5 sm:gap-7">
          <p className="font-suisse-intl-medium text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
            (3–5 minutes to get started)
          </p>
          <p className="font-suisse-intl-medium text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
            A short, guided setup for a smooth transition. We&apos;ll manage the switch while your
            business runs as usual.
          </p>
        </div>
      </div>

      <ul className="flex w-full flex-col items-start gap-3 sm:gap-2">
        {STEPS_AHEAD.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <CheckIcon />
            <span className="font-suisse-intl text-base leading-7 text-white/80 sm:text-lg sm:leading-[28.8px]">
              {item}
            </span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={onStart}
        className="flex h-14 w-full items-center justify-center rounded-full bg-white px-8 font-suisse-intl text-xl leading-5 text-[#2A4775] transition-opacity hover:opacity-90 sm:w-auto"
      >
        Start now
      </button>

      <ReviewsRow />
    </div>
  );
}
